import React, { lazy } from 'react';
export function SocialProofBar() {
  return <div className="w-full bg-[#F5EEF8] border-y border-[#EFE3D4] py-3 sm:py-4 overflow-hidden flex items-center justify-center" data-id="element-187">
      <div className="flex items-center gap-2 sm:gap-3 px-4" data-id="element-188">
        <div className="flex -space-x-2 sm:-space-x-3" data-id="element-189">
          {['https://i.pravatar.cc/100?img=1', 'https://i.pravatar.cc/100?img=5', 'https://i.pravatar.cc/100?img=9', 'https://i.pravatar.cc/100?img=12'].map((src, i) => <img key={i} src={src} alt="Avatar" className="w-6 h-6 sm:w-8 sm:h-8 rounded-full border-2 border-white object-cover" loading="lazy" data-id="element-190" />)}
        </div>
        <div className="flex items-center gap-1.5 sm:gap-2" data-id="element-191">
          <div className="flex text-[#F5C84B] text-[10px] sm:text-xs" data-id="element-192">
            ⭐⭐⭐⭐⭐
          </div>
          <span className="text-[#3D3935] font-bold text-[10px] sm:text-sm" data-id="element-193">
            +1.000 docentes y familias confían
          </span>
        </div>
      </div>
    </div>;
}